module.exports = __webpack_public_path__ + "assets/035df33a0a75d8fd29560053d1d01d32.jpg";